import React from "react";
import "../styles/footer.css";

const Footer = ({ isLanding, lang }) => (
  <div>
    <footer>
      <div className="key_download-container">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <h5>{lang.footer.onlineProduct}</h5>
              <ul>
                <li>
                  <a
                    href="https://online.berjayasompo.com.my/SompoMotor/bm/"
                    target="_blank"
                  >
                    {lang.footer.onlineCarIns}
                  </a>
                </li>
                <li>
                  <a
                    href="https://online.berjayasompo.com.my/motorcycle/bm/"
                    target="_blank"
                  >
                    {lang.footer.onlineMotorCycleIns}
                  </a>
                </li>
                <li>
                  <a
                    href="https://online.berjayasompo.com.my/travel-insurance/insurans-perjalanan/"
                    target="_blank"
                  >
                    {lang.footer.onlineTravelIns}
                  </a>
                </li>
                {/* <li><a href="https://online.berjayasompo.com.my/cashNow/insurans-pendapatan-hospital/" target="_blank">{lang.footer.onlineCashNowIns}</a></li> */}
                {/* <li><a href="https://online.berjayasompo.com.my/medicNow/insurans-perubatan/" target="_blank">{lang.footer.onlineMedicNowIns}</a></li> */}
                <li>
                  <a
                    href="https://online.berjayasompo.com.my/homeNow/insurans-kandungan-rumah/"
                    target="_blank"
                  >
                    {lang.footer.onlineHomeNowIns}
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-4">
              <h5>{lang.footer.keyDownload}</h5>
              <ul>
                <li>
                  <a
                    href="/homeNow/docs/PDS_SOMPO HomeNow_BM_0324.pdf"
                    target="_blank"
                  >
                    {lang.footer.pds}
                  </a>
                </li>
                <li>
                  <a
                    href="/homeNow/docs/SOMPO Home Now PW BM Ver_Finalized (003).pdf"
                    target="_blank"
                  >
                    {lang.footer.pwt}
                  </a>
                </li>
                {/* <li><a href="/homeNow/docs/Beneficiary_Nomination.pdf" target="_blank">Beneficiary Nomination Form</a></li> */}
              </ul>
            </div>
            {/* <div className="col-md-4">
				<h5>CONTACT US</h5>
				<div className="icon">
					<i className="fa fa-phone" aria-hidden="true"></i>
				</div>
				<div className="text">
					<ul>
						<li className="bold">Customer Service</li>
						<li>8:30 AM - 5:00 PM (Monday to Friday)</li>
						<li>1 800 889 933 (within Malaysia)</li>
						<li>+603 2170 7300 (overseas)</li>
						<li>24/7 Worldwide Assistance </li>
						<li>+603 7628 3860 / +603 7841 5770</li>
					</ul>
				</div>
			</div> */}
            <div className="col-md-4">
              <h5>{lang.footer.contactUs}</h5>
              {/* <div className="icon">
					<i className="fa fa-map-marker" aria-hidden="true"></i>
				</div> */}
              <div className="text">
                <ul>
                  <li className="bold">{lang.footer.address}</li>
                  {/* <li className="bold">Berjaya Sompo Insurance Berhad
							Registration No: 198001008821 (62605-U)</li> */}
                  <li>
                    Level 36, Menara Bangkok Bank, 105, Jalan Ampang, 50450
                    Kuala Lumpur
                  </li>
                </ul>
              </div>
              <div className="text mt-3">
                <ul>
                  <li className="bold">{lang.footer.cs}</li>
                  <li>{lang.footer.time}</li>
                  <li>{lang.footer.tel1}</li>
                  <li>{lang.footer.tel2}</li>
                  <li className="mt-2">{lang.footer.worldWideAssistance} </li>
                  <li>+603 7628 3860 </li>
                  <li className="mt-2">{lang.footer.breakDownForPrivateCar}</li>
                  <li>1800 18 8033</li>
                  <li className="mt-2">{lang.footer.breakDownForMotorcycle}</li>
                  <li>1300 88 2323</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="social-media_container">
        <div className="container">
          <div className="row social-media">
            <div className="col-md-6 col-6 multi_lang">
              {isLanding ? (
                <>
                  <nav className="navbar navbar-expand-lg ">
                    <ul className="navbar-nav">
                      <li class="nav-item dropdown ml-auto">
                        <a
                          class="multi_lang_nav nav-link dropdown-toggle bold online-menu_pad2"
                          href="#"
                          id="navbarDropdownPortfolio"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {lang.id === "EN" ? `English` : `Bahasa`}
                        </a>
                        <div
                          class="dropdown-menu dropdown-menu-right multi_lang-dropdown"
                          aria-labelledby="navbarDropdownPortfolio"
                        >
                          <a
                            class="dropdown-item"
                            href="https://online.berjayasompo.com.my/homeNow/insurans-kandungan-rumah"
                            hidden={lang.id === "BM" ? true : false}
                          >
                            Bahasa
                          </a>
                          <a
                            class="dropdown-item"
                            href="https://online.berjayasompo.com.my/homeNow/"
                            hidden={lang.id === "EN" ? true : false}
                          >
                            English
                          </a>
                        </div>
                      </li>
                    </ul>
                  </nav>
                </>
              ) : (
                ""
              )}
            </div>
            <div className="col-lg-4 col-md-6 col-6">
              <ul>
                <li>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/SOMPOonline/"
                    rel="noreferrer"
                  >
                    <img src={"/homeNow/images/ico-fb.svg"} alt="Facebook" />
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.instagram.com/berjayasompoinsurance/"
                    rel="noreferrer"
                  >
                    <img
                      src={"/homeNow/images/ico-instagram.svg"}
                      alt="Instagram"
                    />
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.youtube.com/channel/UC4nnYK4l_h1LmK6m-JMelYg"
                    rel="noreferrer"
                  >
                    <img src={"/homeNow/images/ico-utube.svg"} alt="Youtube" />
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/company/berjaya-sompo-insurance-berhad"
                    rel="noreferrer"
                  >
                    <img
                      src={"/homeNow/images/ico-linkedin.svg"}
                      alt="Linkedin"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-footer_container">
        <div className="container">
          <div className="row bottom-footer">
            <div className="col-md-7">
              <ul>
                <li>
                  <a
                    target="_blank"
                    href="https://www.berjayasompo.com.my/terms-conditions"
                  >
                    General Policy Terms &amp; Conditions
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.berjayasompo.com.my/privacy-notice"
                  >
                    Privacy Notice
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.berjayasompo.com.my/legal-notice"
                  >
                    Legal Notice
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.berjayasompo.com.my/disclaimer"
                  >
                    Disclaimer
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.berjayasompo.com.my/whistle-blowing-policy"
                  >
                    Whistle Blowing Policy
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.berjayasompo.com.my/customer-service-charter"
                  >
                    Customer Service Charter
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.pidm.gov.my/pidm2022/files/92/92bdfcde-3534-4a29-9031-5186387623ee.pdf"
                  >
                    Brosur PIDM
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-5 copy">
              <div className="d-inline-block">
                Copyright © 2025 Berjaya Sompo Insurance Berhad <br />{" "}
                Registration No: 198001008821 (62605-U)
              </div>
            </div>
            <div class="container pidm-disclosure">
              <div className="col-md-10 d-inline-block">
                Manfaat-manfaat yang dibayar di bawah sijil/polisi/produk yang
                layak adalah dilindungi oleh PIDM sehingga had perlindungan.
                Sila rujuk
                <a
                  href="https://www.pidm.gov.my/pidm2022/files/92/92bdfcde-3534-4a29-9031-5186387623ee.pdf"
                  target="_blank"
                >
                  {" "}
                  Brosur Sistem Perlindungan Manfaat Takaful dan Insurans PIDM{" "}
                </a>{" "}
                atau hubungi Berjaya Sompo Insurance Berhad atau PIDM (layari{" "}
                <a href="https://www.pidm.gov.my" target="_blank">
                  www.pidm.gov.my
                </a>
                ).
              </div>
              <div className="col-md-2 d-inline-flex justify-content-end">
                <a
                  class="footer-minilogo"
                  href="https://www.pidm.gov.my"
                  target="_blank"
                >
                  <img src="/homeNow/images/footlogo-pidm.png" alt="PIDM" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
);

export default Footer;
